<template>
  <div id="app">
    <!--button id="view2" @click="swapComponent('afflelou')" type="submit">currentComponent: {{currentComponent}}</button>
    <div :is="currentComponent" :swap-component="swapComponent"></div-->
    <div is="afflelou"></div>
  </div>
</template>

<script>
/*
===================================================================================================
IMPORTANTE: 
  - Para importar componentes hay que importar el componente deseado utilizando 'import`
  - Añadirlo a 'components'
  - Utilizar el nombre que le hemos dado al componente para ponerlo en '<div is="foundation"></div>'
====================================================================================================
*/
import ChatbotAfflelou from './components/ChatbotAfflelou.vue'
// import ChatbotFoundation from './components/ChatbotFoundation.vue'
/*import ChatbotAfflelou from './components/ChatbotAfflelou.vue'
import ChatbotSwitch from './components/ChatbotSwitch.vue' */

export default {
  name: 'App',
  data(){
    return{
      currentComponent:'afflelou',
    }
  },
  components: {
    /* 'foundation':ChatbotFoundation, */
     'afflelou':ChatbotAfflelou, 
  },
  methods: {
    swapComponent(component) {
      // FOR TESTING PURPOSES
      console.log("===== CURRENT COMPONENT", this.currentComponent);
      if(this.currentComponent === 'foundation')
        this.currentComponent = 'afflelou';
      else
        this.currentComponent = 'foundation';

      // this.currentComponent = component;
    },
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
